"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = LabelMulti;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Label = require("./Label.styles");

var propTypes = {
  selectedOptions: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  // complex object not worth declaring the shape of the strcuture
  options: _propTypes["default"].object.isRequired // eslint-disable-line

};

function getFormattedLabel(selectedOptions, options) {
  return selectedOptions.map(function (index) {
    var option = options[index];
    if (!option) return null;

    if (typeof option.content === "string") {
      return option.content;
    }

    if (option.label) {
      return option.label;
    }

    throw new Error("The trigger label on the ListBox needs that either <ListBox.Option> children are typeof string\n      or a label prop is add to the <ListBox.Option label='my description'> component");
  }).filter(function (label) {
    return label !== null;
  }).join(", ");
}

function LabelMulti(props) {
  var optionsLength = props.selectedOptions.length;
  var label = getFormattedLabel(props.selectedOptions, props.options);

  if (optionsLength > 1) {
    return /*#__PURE__*/_react["default"].createElement(_StyledSpan, null, /*#__PURE__*/_react["default"].createElement("span", null, "(", optionsLength, ")\xA0"), label);
  }

  return /*#__PURE__*/_react["default"].createElement(_StyledSpan2, null, label);
}

LabelMulti.propTypes = propTypes;

var _StyledSpan = (0, _styledComponents["default"])("span").withConfig({
  displayName: "LabelMulti___StyledSpan",
  componentId: "sc-1jpuj4v-0"
})(["", ""], _Label.labelStyles);

var _StyledSpan2 = (0, _styledComponents["default"])("span").withConfig({
  displayName: "LabelMulti___StyledSpan2",
  componentId: "sc-1jpuj4v-1"
})(["", ""], _Label.labelStyles);
//# sourceMappingURL=LabelMulti.js.map